(function () {
  if (window.__studio2831CollectionBackInitialized) return;
  window.__studio2831CollectionBackInitialized = true;

  document.addEventListener('click', function (event) {
    const clicked = event.target;
    if (!(clicked instanceof Element)) return;

    const backLink = clicked.closest('[data-studio2831-collection-back]');
    if (!backLink) return;

    let previousPage;
    try {
      previousPage = new URL(document.referrer);
    } catch (_) {
      // Visitors arriving from ads or bookmarks use the homepage fallback.
      return;
    }

    // Never navigate to external referrers. The originating collection
    // is used only when the shopper actually came from a collection page.
    if (previousPage.origin !== window.location.origin) return;
    if (!/\/collections\/[^/]+(?:\/|$)/.test(previousPage.pathname)) return;

    event.preventDefault();
    window.location.assign(previousPage.href);
  });
})();
